import React from 'react';

export interface GuideProviderProps {
  isCard?: boolean;
}

const GuideContext = React.createContext<GuideProviderProps>({
  isCard: false
});

export const GuideProvider = GuideContext.Provider;
export default GuideContext;
